// extracted by mini-css-extract-plugin
export default {"multilanguageWrapper":"event-description_multilanguageWrapper__N-qPD"};